import { render, staticRenderFns } from "./roleTree.vue?vue&type=template&id=00926b74&scoped=true&"
import script from "./roleTree.vue?vue&type=script&lang=js&"
export * from "./roleTree.vue?vue&type=script&lang=js&"
import style0 from "./roleTree.vue?vue&type=style&index=0&id=00926b74&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00926b74",
  null
  
)

export default component.exports